import React from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

const Footer = () => {

    const navigateTo = useNavigate();

    return (
        < footer id="contact" className="pt-16 pb-8 bg-zonex-darkGray relative" >
            {/* Subtle red accent light */}
            <div className="absolute top-0 left-1/4 w-1/3 h-1/3 bg-zonex-red/30 rounded-full blur-3xl"></div>

            <div className="container mx-auto px-4 relative z-10">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
                    {/* Company Info */}
                    <div>
                        <div className="flex items-center mb-6">
                        {/* Logo */}
                        <Link to="/" className="flex items-center">
                            <img
                                src="/zonx.png"
                                alt="ZoneX"
                                className="h-6 w-auto object-contain"
                            />
                        </Link>
                        </div>
                        <p className="text-zonex-gray-700 mb-6">
                            The future of parking and vehicle services, all in one convenient platform.
                        </p>
                        <div className="flex space-x-4">
                            <a
                                href="#"
                                aria-label="Facebook"
                                className="w-10 h-10 bg-zonex-red/10 rounded-full flex items-center justify-center hover:bg-zonex-red hover:text-white transition-colors"
                            >
                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"></path></svg>
                            </a>
                            <a
                                href="#"
                                aria-label="Twitter"
                                className="w-10 h-10 bg-zonex-red/10 rounded-full flex items-center justify-center hover:bg-zonex-red hover:text-white transition-colors"
                            >
                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"></path></svg>
                            </a>
                            <a
                                href="#"
                                aria-label="Instagram"
                                className="w-10 h-10 bg-zonex-red/10 rounded-full flex items-center justify-center hover:bg-zonex-red hover:text-white transition-colors"
                            >
                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0z"></path><path d="M12 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8z"></path></svg>
                            </a>
                        </div>
                    </div>

                    {/* Services Column */}
                    <div>
                        <h4 className="text-lg font-semibold mb-4 text-zonex-gray-900">
                            <span className="border-b-2 border-zonex-red pb-1 ">Company</span>
                        </h4>
                        <ul className="space-y-2">
                            <li>
                                <span
                                    onClick={() => navigateTo('/about')}
                                    className="text-zonex-gray-700 hover:text-zonex-red transition-colors cursor-pointer"
                                >
                                    About Us
                                </span>
                            </li>
                            <li>
                                <span
                                    onClick={() => navigateTo('/contact')}
                                    className="text-zonex-gray-700 hover:text-zonex-red transition-colors cursor-pointer"
                                >
                                    Contact
                                </span>
                            </li>
                            {/* <li><a href="#" className="text-gray-400 hover:text-zonex-red transition-colors">Press</a></li>
                <li><a href="#" className="text-gray-400 hover:text-zonex-red transition-colors">Blog</a></li> */}
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-lg font-semibold mb-4 text-zonex-gray-900">
                            <span className="border-b-2 border-zonex-red pb-1">Features</span>
                        </h4>
                        <ul className="space-y-2">
                            <li><a onClick={() => navigateTo('/parking')} className="text-zonex-gray-700 hover:text-zonex-red transition-colors cursor-pointer">Parking Reservations</a></li>
                            <li><a onClick={() => navigateTo('/mechanics')} className="text-zonex-gray-700 hover:text-zonex-red transition-colors cursor-pointer">Mechanic Booking</a></li>
                            <li><a onClick={() => navigateTo('/contact')} className="text-zonex-gray-700 hover:text-zonex-red transition-colors cursor-pointer">Partner With Us</a></li>
                        </ul>
                    </div>

                    {/* Contact Column */}
                    <div>
                        <h4 className="text-lg font-semibold mb-4 text-zonex-gray-900">
                            <span className="border-b-2 border-zonex-red pb-1">Contact</span>
                        </h4>
                        <ul className="space-y-4">
                            <li className="flex items-start">
                                <div className="mr-3 text-zonex-red p-2 bg-zonex-red/10 rounded-lg shadow-sm">
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path></svg>
                                </div>
                                <span className="text-zonex-gray-700 text-left flex-1">Dodhmane complex, 1st floor, Muddinaplaya main road, Vishwaneedam Post, Bangalore-560091</span>
                            </li>
                            <li className="flex items-start">
                                <div className="mr-3 text-zonex-red p-2 bg-zonex-red/10 rounded-lg shadow-sm">
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg>
                                </div>
                                <span className="text-zonex-gray-700">info@zone-x.in</span>
                            </li>
                            <li className="flex items-start">
                                <div className="mr-3 text-zonex-red p-2 bg-zonex-red/10 rounded-lg shadow-sm">
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path></svg>
                                </div>
                                <span className="text-zonex-gray-700">+91 84315 13412</span>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Bottom Section with Copyright */}
                <div className="border-t border-zonex-gray-200 pt-8 mt-8">
                    <div className="flex flex-col md:flex-row justify-between items-center">
                        <p className="text-zonex-gray-600 text-sm">© {new Date().getFullYear()} ZoneX. All rights reserved.</p>
                        <div className="flex space-x-6 mt-4 md:mt-0">
                            <a href="#" className="text-zonex-gray-600 hover:text-zonex-red transition-colors text-sm">Privacy Policy</a>
                            <a href="#" className="text-zonex-gray-600 hover:text-zonex-red transition-colors text-sm">Terms of Service</a>
                            <a href="#" className="text-zonex-gray-600 hover:text-zonex-red transition-colors text-sm">Cookie Policy</a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;